import {Button, Stack} from '@mui/material';
import React from 'react';

import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {AlertInfo, Row} from 'presentation/components';
import {useContractStatus} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';
import {formatMasks, formatText} from 'presentation/utils';
import {AlertEnum} from 'presentation/pages/private/profile/store/changeDataAlertStore/types';
import {useMediaQueries} from 'presentation/pages';
import {AddressDataProps} from './types';

const {address, edit, successAlert, errorAlert} =
	translations['pt-br'].privateFlow.profile.changeData;

const AddressData = ({addressData, onOpenForm, status}: AddressDataProps) => {
	const {isMobile} = useMediaQueries();
	const {dsComplemento, nmBairro, nmRua, nmUf, nmCidade, nmTipoLogradouro, nuEndereco, nuCep} =
		addressData;
	const showAlert = status.status && status.type === AlertEnum.ADDRESS;
	const {typeMessage} = status;
	const message = {
		success: successAlert.address,
		error: errorAlert,
	};

	const {isValid, isCancelledAtFiveYears} = useContractStatus();

	return (
		<Stack gap={2}>
			{showAlert ? (
				<AlertInfo.Root severity={typeMessage}>
					<AlertInfo.Title sx={{mb: 0}} title={message[typeMessage]} />
				</AlertInfo.Root>
			) : null}
			<Row.Simple title={address.zipCode} value={nuCep ? formatMasks('cep', nuCep) : '-'} />

			<Row.Compound
				items={[
					{
						title: address.address,
						value:
							nmTipoLogradouro && nmRua
								? formatText(`${nmTipoLogradouro}. ${nmRua}`)
								: '-',
					},
					...(isMobile
						? []
						: [
								{
									title: address.number,
									value: nuEndereco || '-',
								},
							]),
				]}
			/>

			{isMobile ? <Row.Simple title={address.number} value={nuEndereco || '-'} /> : null}

			<Row.Compound
				items={[
					{
						title: address.complement,
						value: dsComplemento ? formatText(dsComplemento) : '-',
					},
					{
						title: address.district,
						value: nmBairro ? formatText(nmBairro) : '-',
					},
				]}
			/>
			<Row.Compound
				hiddenDivider
				items={[
					{
						title: address.city,
						value: nmCidade ? formatText(nmCidade) : '-',
					},
					{
						title: address.state,
						value: nmUf ? nmUf.toUpperCase() : '-',
					},
				]}
			/>
			<Stack direction="row" justifyContent="flex-end">
				{isValid || isCancelledAtFiveYears ? (
					<Button
						variant="text"
						onClick={onOpenForm}
						data-tag-id={MyProfileEnum.CLICK_ALTERAR_ENDERECO}>
						{edit}
					</Button>
				) : null}
			</Stack>
		</Stack>
	);
};

export {AddressData};
